import Vue from 'vue'
import App from './App.vue'
import router from './router/PROJECT_NAME.js'
import store from './store'
import qs from 'qs'
import './plugins/hammer.js'
// import './plugins/qqMap'
import './plugins/element.js'
import '@assets/styles/main.scss'
import '@assets/styles/font.scss'
import Distpicker from 'v-distpicker'
import VueLazyload from 'vue-lazyload'
Vue.component('v-distpicker', Distpicker)

// 自定义滚动指令，传入value为数组[上滚事件，下滚事件]
Vue.directive('CustomScroll', {
  bind(el, binding) {
    el.addEventListener('wheel', ({ wheelDelta }) => {
      // 上滚为正，下滚为负
      if (wheelDelta > 0) {
        binding.value[0]()
      } else {
        binding.value[1]()
      }
    })
  }
})
console.log('NODE_ENV',process.env.NODE_ENV)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: require('./assets/imgs/bookshelfdetail/loading.gif'),
  attempt: 3
})
Vue.prototype.qs = qs
//腾讯地图定位插件
// Vue.prototype.geolocation = new qq.maps.Geolocation('C6HBZ-TCGEU-WC3VD-4KYJR-PRTV5-3KFOT', 'test')
// console.log(Vue.prototype.geolocation)
// Vue.prototype.geolocation.getIpLocation(
//   (res) => {
//     console.log(res)
//   },
//   () => {
//     console.log('error')
//   }
// )
Vue.prototype.$setDocumentTitle = function(title) {
  document.title = title
}
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
